export const ERROR_TOAST = {
  title: 'Er is iets mis gegaan',
  toaster: 'b-toaster-bottom-right',
  variant: 'danger',
  solid: true
}
